<template>
	<div>
			<v-layout row wrap class="pl-4 pr-4 pt-4 pb-4">        
				<v-flex lg6>
					<br />
					<label class="text-lg-left noMargin"><strong>Manufacturer Users</strong></label>
				</v-flex>
				<v-flex lg6>
					<br />
					<label class="text-lg-left noMargin"><strong>Customer Users</strong></label>
				</v-flex>
				<v-flex lg5>
					<label class="blackLabel">Alias</label>
					<v-text-field label="Alias" v-model="objUserSettings.manufacturerAlias" solo></v-text-field>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">&nbsp;</label>
					<swatches v-model="objUserSettings.manufacturerColor" colors="text-advanced" popover-to="right" />
				</v-flex>
				<v-flex lg5>
					<label class="blackLabel">Alias</label>
					<v-text-field label="Alias" v-model="objUserSettings.customerAlias" solo></v-text-field>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">&nbsp;</label>
					<swatches v-model="objUserSettings.customerColor" colors="text-advanced" popover-to="right" />
				</v-flex>
				<v-flex lg6>
					<br />
					<label class="text-lg-left noMargin"><strong>Specific Users</strong></label>
				</v-flex>
				<v-flex lg6>
					<br />
					<label class="text-lg-left noMargin"><strong>Public Users</strong></label>
				</v-flex>
				<v-flex lg5>
					<label class="blackLabel">Alias</label>
					<v-text-field label="Alias" v-model="objUserSettings.specificAlias" solo></v-text-field>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">&nbsp;</label>
					<swatches v-model="objUserSettings.specificColor" colors="text-advanced" popover-to="right" />
				</v-flex>
				<v-flex lg5>
					<label class="blackLabel">Alias</label>
					<v-text-field label="Alias" v-model="objUserSettings.publicAlias" solo></v-text-field>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">&nbsp;</label>
					<swatches v-model="objUserSettings.publicColor" colors="text-advanced" popover-to="right" />
				</v-flex>
				<div class="pl-4 pr-1 pb-2 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<!--<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
						<!--<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncEditSettings()">Save</v-btn>-->
						<v-btn color="success" class="text-xs-right" @click.stop="fncEditSettings()">Save</v-btn>
					</div>
				</div>
			</v-layout> 
		</v-container>	
      </div>
</template>

<script>

	import { mapGetters } from 'vuex';
    import Swatches from 'vue-swatches';
    import "vue-swatches/dist/vue-swatches.min.css";

	export default {
        name: 'UserSettings',
        components: { Swatches },
		data () {
			return {						
			}
		},
		methods: {
            fncHideModal () {
                this.$store.commit('hideModal');
            },
            fncEditSettings() {
              this.$store.dispatch('fncEditSettings', this.objUserSettings);              
              var objAlias = {
                manu_user_alias: this.objUserSettings.manufacturerAlias,
                manu_user_clr: this.objUserSettings.manufacturerColor,
                customer_user_alias: this.objUserSettings.customerAlias,
                customer_user_clr: this.objUserSettings.customerColor,
                specifier_user_alias: this.objUserSettings.specificAlias,
                specifier_user_clr: this.objUserSettings.specificColor,				
                public_user_alias: this.objUserSettings.publicAlias,
                public_user_clr: this.objUserSettings.publicColor
              }
              this.$store.commit('fncUpdateObjAuth', objAlias, { root: true });
			}
		},
		computed: {
			...mapGetters([
			    'objAuthorize',
				'objUserSettings'
			])
		},
		created() {
            // this.$store.commit('setObjUserSettings', this.objAuthorize);
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>